// extracted by mini-css-extract-plugin
export default {"text__style__block":"RangeEstimation_text__style__block__0a4Mt"};